import {
    CLOSE_TOBA_REJECT_MODAL,
    OPEN_TOBA_REJECT_MODAL,
    ADD_TOBA_FORM_ATTACHMENT,
    CHANGE_NEW_TOBA_PROPERTIES,
    CHANGE_TOBA_SETTINGS,
    CLEAR_NEW_TOBA,
    RECEIVE_BAD_RESPONSE_POST_NEW_TOBA,
    RECEIVE_FAILURE_TOBA_MESSAGE,
    RECEIVE_POST_NEW_TOBA_RESPONSE,
    RECEIVE_TOBA_MESSAGE,
    REMOVE_FETCHED_TOBA_ATTACHMENT,
    REMOVE_TOBA_FORM_ATTACHMENT,
    REQUEST_POST_NEW_TOBA,
    REQUEST_TOBA_MESSAGE,
    GET_TOBA_REVISIONS,
    GET_TOBA_REVISIONS_SUCCESS,
    GET_TOBA_REVISIONS_FAIL,
    POPULATE_TOBA_FORM_FROM_REVISION,
    OPEN_TOBA_REVISION_MODAL,
    CLOSE_TOBA_REVISION_MODAL,
    UPDATE_TOBA_SUCCESS,
    UPDATE_TOBA,
    UPDATE_TOBA_FAIL,
    GET_TOBA_REVISION_BY_ID,
    GET_TOBA_REVISION_BY_ID_SUCCESS,
    GET_TOBA_REVISION_BY_ID_FAIL,
    OPEN_CREATE_REVISION_CONFIRM_MODAL,
    CLOSE_CREATE_REVISION_CONFIRM_MODAL,
    CLOSE_UPDATE_TOBA_CONFIRM_MODAL, OPEN_UPDATE_TOBA_CONFIRM_MODAL
} from "./index";

export function openUpdateTobaConfirmModal(payload) {
    return {
        type: OPEN_UPDATE_TOBA_CONFIRM_MODAL,
        payload: payload
    }
}

export function closeUpdateTobaConfirmModal(payload) {
    return {
        type: CLOSE_UPDATE_TOBA_CONFIRM_MODAL,
        payload: payload
    }
}

export function openCreateRevisionConfirmModal(payload) {
    return {
        type: OPEN_CREATE_REVISION_CONFIRM_MODAL,
        payload: payload
    }
}

export function closeCreateRevisionConfirmModal(payload) {
    return {
        type: CLOSE_CREATE_REVISION_CONFIRM_MODAL,
        payload: payload
    }
}

export function getTobaRevisionById(payload) {
    return {
        type: GET_TOBA_REVISION_BY_ID,
        payload: payload
    }
}

export function getTobaRevisionByIdSuccess(payload) {
    return {
        type: GET_TOBA_REVISION_BY_ID_SUCCESS,
        payload: payload
    }
}

export function getTobaRevisionByIdFail(payload) {
    return {
        type: GET_TOBA_REVISION_BY_ID_FAIL,
        payload: payload
    }
}

export function updateToba(payload) {
    return {
        type: UPDATE_TOBA,
        payload: payload
    }
}

export function updateTobaSuccess(payload) {
    return {
        type: UPDATE_TOBA_SUCCESS,
        payload: payload
    }
}

export function updateTobaFail(payload) {
    return {
        type: UPDATE_TOBA_FAIL,
        payload: payload
    }
}

//action that opens the toba revision modal
export function openTobaRevisionModal(payload) {
    return {
        type: OPEN_TOBA_REVISION_MODAL,
        payload: payload
    }
}

//action that closes the toba revision modal
export function closeTobaRevisionModal(payload) {
    return {
        type: CLOSE_TOBA_REVISION_MODAL,
        payload: payload
    }
}

//action that populates the toba form from a toba revision
export function populateTobaFormFromRevision(payload) {
    return {
        type: POPULATE_TOBA_FORM_FROM_REVISION,
        payload: payload
    }
}

//action that requests toba revisions
export function getTobaRevisions(payload) {
    return {
        type: GET_TOBA_REVISIONS,
        payload: payload
    }
}

//action that receives toba revisions
export function getTobaRevisionsSuccess(payload) {
    return {
        type: GET_TOBA_REVISIONS_SUCCESS,
        payload: payload
    }
}

//action that receives error from getting the toba revisions
export function getTobaRevisionsFail(payload) {
    return {
        type: GET_TOBA_REVISIONS_FAIL,
        payload: payload
    }
}

//action that removes a fetched toba attachment
export function removeFetchedTobaAttachment(tobaIndex) {
    return {
        type: REMOVE_FETCHED_TOBA_ATTACHMENT,
        payload: tobaIndex
    }
}

//action that adds an attachment for the toba
export function addTobaFormAttachment(attachment) {
    return {
        type: ADD_TOBA_FORM_ATTACHMENT,
        payload: attachment
    }
}

//action that removes an attachment from the toba form
export function removeTobaFormAttachment(key) {
    return {
        type: REMOVE_TOBA_FORM_ATTACHMENT,
        payload: key
    }
}
//action that opens the toba reject modal
export function openTobaRejectModal(payload) {
    return {
        type: OPEN_TOBA_REJECT_MODAL,
        payload: payload
    }
}

//action that closes the toba reject modal
export function closeTobaRejectModal(payload) {
    return {
        type: CLOSE_TOBA_REJECT_MODAL,
        payload: payload
    }
}

export function changeNewTobaProperties(property, data) {
    return {
        type: CHANGE_NEW_TOBA_PROPERTIES,
        payload: {
            key: property,
            value: data
        }
    }
}

export function requestPostNewToba(payload) {
    return {
        type: REQUEST_POST_NEW_TOBA,
        payload
    }
}

export function receivePostNewTobaResponse(repsonse) {
    return {
        type: RECEIVE_POST_NEW_TOBA_RESPONSE,
        payload: repsonse
    }
}

export function receiveBadResponsePostNewToba(response) {
    return {
        type: RECEIVE_BAD_RESPONSE_POST_NEW_TOBA,
        payload: response
    }
}

export function clearNewToba(){
    return{
        type: CLEAR_NEW_TOBA
    }
}



export function changeTobaSettings(key, value) {
    return {
        type: CHANGE_TOBA_SETTINGS,
        payload: {
            key, value
        }
    }
}


export function requestTobaMessage(){
    return {
        type: REQUEST_TOBA_MESSAGE
    }
}

export function receiveTobaMessage(payload){
    return {
        type: RECEIVE_TOBA_MESSAGE,
        payload
    }
}

export function receiveFailureTobaMessage(payload){
    return {
        type: RECEIVE_FAILURE_TOBA_MESSAGE,
        payload
    }
}
